import { Login } from "../features/authentication";

const LoginPage = () => {
    return <Login />;
};

export default LoginPage;
